import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { SvgProvider } from '../../providers/svg/svg';
import { RefdataProvider } from "../../providers/refdata/refdata";

import { jQuery } from 'jquery/dist/jquery';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BhutilProvider } from '../../providers/bhutil/bhutil';

enum ButtonTypes {
  DETAILS_BUTTON,
  DETAILS_CHILD,
  NONE,
  PARENT,
  ONE_TO_FIVE_PARENT,
  ONE_TO_FIVE_CHILD,
  COLOR_PARENT,
  /*COLOR_CHILD,
  COLOR_CHILD_IMAGE,*/
  CELL_COLOR,
  CELL_CLARITY_NO_IMAGE,
  CELL_CLARITY_IMAGE
}

@Component({
  selector: 'beer-iba',
  templateUrl: 'beer-iba.html',
  styleUrls: ['./beer-iba.scss'],
  standalone: false,
  // imports: [
  //   CommonModule,
  //   IonicModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class BeerIbaComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('ibaCanvas') ibaCanvas: ElementRef;
  @ViewChild('ibaSvgContainer') ibaSvgContainer: ElementRef;

  private _CANVAS: any;
  private _CONTEXT: any;

//  private _svgDiv: jQuery<HTMLElement>;
  private _SVGDIV: HTMLDivElement;

  valueIntensity: number;
  valueBody: number;
  valueAstringency: number;
  values: Array<number> = new Array<number>();

  buttons: Array<any>;

  //size: number;
  startX: number;
  startY: number;
  xOffset: number;
  yOffsetFull: number;
  yOffsetHalf: number;

  ibaWidth: number = window.innerWidth;
  ibaHeight: number = window.innerWidth;

  middleX: number = 0;
  middleY: number = 0;

  //margins from borders
  left: number = 5;
  right: number = 5;
  top: number = 5;
  bottom: number = 5;

  // a cell is 2 * radius wide
  radius: number = 0;

  cellHeight: number = 0;

  //number of radius that the view is "wide"
  widthCount: number = 5;

  w: number = 0;
  h: number = 0;

  smallButtonScale: number = 0.99;

  private updateIbaSubscription: any;
  constructor(
    private svgProvider: SvgProvider,
    private refdata: RefdataProvider,
    private events: AppEventService,
    private translateService: TranslateService,
    private bhutil: BhutilProvider
  ) {
    this.log("constructor called");
    this.buttons = [
      {
        identifier: "color1",
        buttons: [
          {
            svgPath: "assets/svg/icon_mouthfeel_intensity.svg",
            type: ButtonTypes.CELL_CLARITY_IMAGE,
            colors: ["#FFFFFF"],
            selected: false,
            label: translateService.instant('BUTTONS.INTENSITY'),
            key: "intensity"
          },
          {
            svgPath: "assets/svg/icon_mouthfeel_body.svg",
            type: ButtonTypes.CELL_CLARITY_IMAGE,
            colors: ["#FFFFFF"],
            selected: false,
            label: translateService.instant('BUTTONS.BODY'),
            key: "body"
          },
          {
            svgPath: "assets/svg/icon_mouthfeel_astringency.svg",
            type: ButtonTypes.CELL_CLARITY_IMAGE,
            colors: ["#FFFFFF"],
            selected: false,
            label: translateService.instant('BUTTONS.ASTRINGENT'),
            key: "dryness"
          }
        ],
        selected: false,
        type: ButtonTypes.NONE
      }
    ];

    let that = this;

    this.updateIbaSubscription = (ibaEvent: any) => {
      this.log("updateIbaSubscription called with event " + JSON.stringify(ibaEvent));
      // receiving an update in i,b,a values
      let iReceived = ibaEvent.intensity;
      let bReceived = ibaEvent.body;
      let aReceived = ibaEvent.astringency;

      this.valueIntensity = iReceived;
      this.valueBody = bReceived;
      this.valueAstringency = aReceived;

      this.values = [];
      this.values.push(this.valueIntensity);
      this.values.push(this.valueBody);
      this.values.push(this.valueAstringency);

      that.drawCellsSvg(this.buttons[0].buttons, this.startX, this.startY);
    }
    this.events.subscribe("update:iba", this.updateIbaSubscription);
  }

  ngOnInit() {
    this.log("ngOnInit called");
    this.events.subscribe("beer-detail:update:beer-iba", this.updateIbaSubscription);
  }
  initCanvas() {
    this.log("initCanvas called with this.values = " + JSON.stringify(this.values) + " and this._SVGDIV = " + JSON.stringify(this._SVGDIV));
    if (this._CANVAS.getContext) {
      this.setupCanvas();
    }
  }

  ngOnDestroy() {
    this.log("ngOndestroy called");
    this.events.unsubscribe("beer-detail:update:beer-iba", this.updateIbaSubscription);
    this.events.unsubscribe("update:iba", this.updateIbaSubscription);
  }

  setupCanvas() {
    this.log("setupCanvas called with this.values = " + JSON.stringify(this.values) + " and this._SVGDIV = " + JSON.stringify(this._SVGDIV));
    this._CONTEXT = this._CANVAS.getContext('2d');
    this._CONTEXT.fillStyle = "#FFFFFF";
    this._CONTEXT.fillRect(0, 0, this.w, this.h);
  }

  clearCanvas() {
    this.log("clearCanvas called with this.values = " + JSON.stringify(this.values) + " and this._SVGDIV = " + JSON.stringify(this._SVGDIV));
    this._CONTEXT.clearRect(0, 0, this._CANVAS.width, this._CANVAS.height);
    this.setupCanvas();
  }

  ngAfterViewInit() {

    this._CANVAS = this.ibaCanvas.nativeElement;
    this._SVGDIV = this.ibaSvgContainer.nativeElement;

//    this._svgDiv = $('#ibaSvgContainer');
    this.log("ngAfterViewInit called with this.values = " + JSON.stringify(this.values) + " and this._SVGDIV = " + JSON.stringify(this._SVGDIV));

    this.w = Math.trunc(window.innerWidth * 0.3);
    this._CANVAS.width = this.w;

    this.h = Math.trunc(window.innerWidth * 0.6);
    this._CANVAS.height = this.h;

    this.left = 5;
    this.right = 5;
    this.top = 5;
    this.bottom = 5;

    this.radius = (this.w - this.left - this.right) / 4.0;
    this.cellHeight = Math.sqrt(3.0) * this.radius;
    let totalHeight = this.cellHeight * 3;

    if (totalHeight > this.h) {
      // work the other way around
      this.cellHeight = (this.h - this.top - this.bottom) / 3;
      this.radius = this.cellHeight / Math.sqrt(3.0);

      this.top = 0;

      this.startX = this.radius;
      this.startY = this.top + this.radius;

    } else {
      let heightDiff = (this.h - totalHeight - this.top - this.bottom) / 2;
      this.top += heightDiff;
      //this.size = this.radius;
      this.startX = this.radius;
      this.startY = this.top + this.radius;

    }

    this.xOffset = 0; //this.radius; //this.size * 1.5;
    this.yOffsetFull = this.radius * 1.75;
    this.yOffsetHalf = this.radius * 1.75 / 2;

    this.initValues();

    // this.initCanvas();

    // this.drawCells(this.buttons, this.startX, this.startY);
    this.drawCellsSvg(this.buttons[0].buttons, this.startX, this.startY);

  }

  private initValues() {
    this.valueIntensity = 0;
    this.valueBody = 0;
    this.valueAstringency = 0;

    this.values.push(this.valueIntensity);
    this.values.push(this.valueBody);
    this.values.push(this.valueAstringency);
  }

  private drawCellsSvg(buttons, startX, startY) {
    this.log("drawCellsSvg called with this.values = " + JSON.stringify(this.values) + " and this._SVGDIV = " + JSON.stringify(this._SVGDIV));
    var mySvg = this.svgElementStart();

    var iconScale = 0.6;
    var iconSize = this.radius * 1.8 * iconScale;

    for (let ctr = 0; ctr < buttons.length; ctr++) {
     var buttonY = startY + (ctr * this.yOffsetFull);

     var iHexagon = this.svgProvider.drawHexagon('ibaHex_' + ctr, startX, buttonY, this.radius, this.refdata.aromaHexagonStyle);

     var iconX = startX - iconSize/2.0;
     var iconY = buttonY - this.radius + this.radius * 0.25;
     var iIcon = this.svgProvider.drawIcon(iconX, iconY, buttons[ctr].svgPath, iconSize, iconSize);

     var textX = startX;
     var textY = buttonY + this.radius/1.85;
     var iText = this.svgProvider.drawAromaText(buttons[ctr].label, textX, textY);
     mySvg += iHexagon;
     mySvg += iIcon;
     mySvg += iText;

     var smallButtonPosition: Array<any> = new Array<any>();

     let xOffsetSmall = (this.smallButtonScale * this.xOffset / 3);
     let yOffsetFullSmall = (this.smallButtonScale * this.yOffsetFull / 3);
     let yOffsetHalfSmall = (this.smallButtonScale * this.yOffsetHalf / 3);

     let subX = startX + this.radius + (this.smallButtonScale * this.radius / 6);
     let subY = buttonY - (this.smallButtonScale * this.yOffsetHalf / 3);

     smallButtonPosition.push({
       x: subX,
       y: subY
     });
     subY -= (this.smallButtonScale * this.yOffsetHalf / 3);
     subX += (this.smallButtonScale * (this.xOffset + this.radius / 3 + this.radius / 6));
     smallButtonPosition.push({
       x: subX,
       y: subY
     });
     subY += (this.smallButtonScale * this.yOffsetHalf / 3);
     subX += (this.smallButtonScale * (this.xOffset + this.radius / 3 + this.radius / 6));
     smallButtonPosition.push({
       x: subX,
       y: subY
     });
     subY += (this.smallButtonScale * (this.yOffsetFull / 3));
     smallButtonPosition.push({
       x: subX,
       y: subY
     });
     // draw small hexagons
     for (let i = 0; i < 4; i++) {
       var smallX = 0;
       var smallY = 0;
       var smallRadius = (this.smallButtonScale * (this.radius / 3));

       var smallStyle = this.refdata.smallAromaHexagonStyle;

       if (i < this.values[ctr]) {
         smallStyle = smallStyle + 'fill:#5D4C44;';
       }
       else {
         smallStyle = smallStyle + 'fill:none;';
       }

        if (i < Math.round(this.values[ctr])) {
          smallStyle = smallStyle + 'fill:#5D4C44;';
        }
        else {
          smallStyle = smallStyle + 'fill:none;';
        }

        var smallHexagon = this.svgProvider.drawHexagon('ibaHex_small_' + ctr + '_' + i, smallButtonPosition[i].x, smallButtonPosition[i].y, smallRadius, smallStyle);
        mySvg += smallHexagon;
      }
    }

    mySvg += '</svg>';
//    this._svgDiv.empty();
    this._SVGDIV.innerHTML = "";
    //debugger;
//    this._svgDiv.append(mySvg);
    this._SVGDIV.innerHTML = mySvg;
 }
 private svgElementStart() {
   return '<svg xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"' +
          ' xmlns:dc="http://purl.org/dc/elements/1.1/"' +
          ' xmlns:cc="http://creativecommons.org/ns#"' +
          ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"' +
          ' xmlns:svg="http://www.w3.org/2000/svg"' +
          ' xmlns="http://www.w3.org/2000/svg"' +
          ' xmlns:xlink="http://www.w3.org/1999/xlink"' +
          ' xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"' +
          ' xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"' +
          ' id="binary-aromas-svg-svg" version="1.1" ' + this.svgViewAttributes(-5, 0, this.w, this.h) + '>';
 }
 private svgViewAttributes(x, y, width, height) {
   return 'viewBox="' + x + ' ' + y +' ' + width + ' ' + height + '"' +
   ' height="' + height + '" width="' + width + '"';
 }

 private drawCells(buttons: Array<any>, x: number, y: number) {

    let col = 0;

    for (col = 0; col < buttons.length; col++) {

      let colX = this.left + x + col * this.radius * 3 / 2;

      let colY = y;
      if (col == 1)
        colY += col * Math.sqrt(3.0) * this.radius / 2;

      this.drawColumnCells(buttons[col].buttons, colX, colY, col);

      /*const b = buttons[i];

      b.x = x;
      b.y = y;

      this.DrawHexagon(this._CONTEXT, x, y, b.selected, "");*/
      //this.DrawImage(this._CONTEXT, x, y, b.selected, b);

      /*if (b.selected && b.buttons && b.buttons.length > 0 && b.type === ButtonTypes.PARENT) {
        let subX = x + this.xOffset;
        //Recursive call to draw child buttons
        this.DrawBeerhive(b.buttons, subX, this.startY - this.yOffsetHalf);
      } else*/

      /*if (b.selected && b.type === ButtonTypes.ONE_TO_FIVE_PARENT) {
        if (b.detailsButton && b.detailsChildren && b.buttons && b.buttons[5].selected) {
          this.DrawDetailChildren(b);
        } else {
          this.DrawZeroToFive(b);
        }
      } else if (b.selected && b.type === ButtonTypes.COLOR_PARENT) {
        this.DrawColor(b);
      }*/
      //y += this.yOffsetFull;
    }
  }

  private drawColumnCells(buttons: Array<any>, x: number, y: number, col: number) {
    let i = 0;
    for (i = 0; i < buttons.length; i++) {
      const b = buttons[i];

      //this.log("drawing button in col " + col + " at index " + i + " --> " + b.key);

      b.x = x;
      b.y = y;

      /*
      //set the selected values
      if (col == 0 || col == 1) {
        //it is a color button
        let colorStr = "col" + this.selectedColor;
        if (b.key === colorStr) {
          b.selected = true;
          //b.svgPath = "assets/svg/icon__bee.svg";
        }
      }
      else if (col == 2) {
        //it is a clarity button
        let clarityStr = "clarity" + this.selectedClarity;
        if (b.key === clarityStr) {
          //this.log("clarity found!")
          b.selected = true;
        }
        //else
        //this.log("clarity different: **" + b.value + "**|**" + clarityStr + "**");
      }
      */

      //check for color args
      if (b.type === ButtonTypes.CELL_COLOR) {
        let args: any = {
          color: b.colors[0],
          type: b.type,
          selected: b.selected
        };
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, args);

        if (/*b.type === ButtonTypes.CELL_COLOR &&*/ b.selected) {
          //this.log("drawing selected color");
          //the color button has to be selected
          b.svgPath = "assets/svg/icon_bee.svg";
          this.DrawImage(this._CONTEXT, x, y /*- this.radius / 2*/, false, b, this.radius);//moet het b zijn?
        }
      }
      else {
        this.DrawHexagon(this._CONTEXT, x, y, b.selected, "");
        if (b.type === ButtonTypes.CELL_CLARITY_IMAGE) {
          //this.log("drawing image");
          this.DrawImage(this._CONTEXT, x, y /*- this.radius / 2*/, false, b, this.radius);//moet het b zijn?
          this.DrawSmallZeroToFive(b, i);
        }
      }

      y += this.yOffsetFull;
    }
  }

  //draw the rating cells starting from a button
  private DrawSmallZeroToFive(b: any, i: number) {

    //i: 0 => I, i: 1 => B, i: 2 => A
    let smallButtonScale = this.smallButtonScale;

    b.buttons = [];

    let currentValue: number = 0;
    if (i == 0)
      currentValue = this.valueIntensity;
    else if (i == 1)
      currentValue = this.valueBody;
    else if (i == 2)
      currentValue = this.valueAstringency;

    //let xOffsetSmall = (this.smallButtonScale * this.xOffset / 3);
    //let yOffsetFullSmall = (this.smallButtonScale * this.yOffsetFull / 3);
    //let yOffsetHalfSmall = (this.smallButtonScale * this.yOffsetHalf / 3);

    let subX = b.x + this.radius + (smallButtonScale * this.radius / 6);
    let subY = b.y - (smallButtonScale * this.yOffsetHalf / 3);

    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      svgPath: "",
      thisCell: 1,
      parent: b,
      x: subX,
      y: subY
    });
    let colorFill = "#FFFFFF";
    if (currentValue >= 1)
      colorFill = '#5D4C44';
    this.DrawSmallHexagon(this._CONTEXT, subX, subY, false, b.buttons[0], colorFill);

    subY -= (smallButtonScale * this.yOffsetHalf / 3);
    subX += (smallButtonScale * (this.xOffset + this.radius / 3 + this.radius / 6));
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 2,
      parent: b,
      x: subX,
      y: subY
    });
    colorFill = "#FFFFFF";
    if (currentValue >= 2)
      colorFill = '#5D4C44';
    this.DrawSmallHexagon(this._CONTEXT, subX, subY, false, b.buttons[1], colorFill);

    subY += (smallButtonScale * this.yOffsetHalf / 3);
    subX += (smallButtonScale * (this.xOffset + this.radius / 3 + this.radius / 6));
    //subX += this.xOffset + this.radius/3 + this.radius/6;
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 3,
      parent: b,
      x: subX,
      y: subY
    });
    colorFill = "#FFFFFF";
    if (currentValue >= 3)
      colorFill = '#5D4C44';
    this.DrawSmallHexagon(this._CONTEXT, subX, subY, false, b.buttons[2], colorFill);

    subY += (smallButtonScale * (this.yOffsetFull / 3));
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      thisCell: 4,
      parent: b,
      x: subX,
      y: subY
    });
    colorFill = "#FFFFFF";
    if (currentValue >= 4)
      colorFill = '#5D4C44';
    this.DrawSmallHexagon(this._CONTEXT, subX, subY, false, b.buttons[3], colorFill);

    /*subY += (this.smallButtonScale * (this.yOffsetHalf / 3));
    subX -= (this.smallButtonScale * (this.xOffset + this.radius / 3 + this.radius / 6));
    b.buttons.push({
      type: ButtonTypes.ONE_TO_FIVE_CHILD,
      svgPath: "assets/svg/plus.svg",
      thisCell: 4,
      parent: b,
      x: subX,
      y: subY
    });
    this.DrawSmallHexagon(this._CONTEXT, subX, subY, false, b.buttons[4]);*/


    /*
    if (b.detailsButton) {
      subY -= this.yOffsetFull;
      b.buttons.push({
        type: b.detailsButton.type,
        svgPath: b.detailsButton.svgPath,
        parent: b,
        x: subX,
        y: subY
      });
      this.DrawHexagon(this._CONTEXT, subX, subY, false, b.buttons[5]);
      this.DrawImage(this._CONTEXT, subX, subY, false, b.buttons[5], this.radius);
    }*/
  }

  //draw the hex shapes
  private DrawHexagon(ctx: CanvasRenderingContext2D, x: number, y: number, isSelected: boolean, args: any = null) {
    ctx.beginPath();
    ctx.moveTo(x + this.radius * Math.cos(0), y + this.radius * Math.sin(0));

    //Draw hexagon sides
    for (let side = 0; side < 7; side++) {
      ctx.lineTo(x + this.radius * Math.cos(side * 2 * Math.PI / 6), y + this.radius * Math.sin(side * 2 * Math.PI / 6));
    }

    //pick fill type
    if (isSelected) {
      ctx.fillStyle = "#ffdd58";
      ctx.fill();
    }

    if (args.type === ButtonTypes.ONE_TO_FIVE_CHILD) {
      if (args.thisCell <= args.parent.value) {
        ctx.fillStyle = "#ffdd58";
        ctx.fill();
      } else {
        ctx.fillStyle = "#ffffcd";
        ctx.fill();
      }
    }

    if (args.type === ButtonTypes.CELL_COLOR || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE) {
      //this.log("this is a color type");
      //console.dir(args);
      ctx.fillStyle = args.color;
      ctx.fill();
    }

    //selected clarity cell
    if (args.selected && (args.type === ButtonTypes.CELL_CLARITY_IMAGE || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE)) {
      ctx.fillStyle = "#ffdd58";
      ctx.fill();
    }

    /*
    //selected color cell => show bee icon
    if (args.selected && args.type === ButtonTypes.COLOR_CHILD) {
      ctx.fillStyle = "#0000ff"; //"#ffdd58";
      ctx.fill();
    }*/

    ctx.strokeStyle = "#ffcc00";
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  private DrawSmallHexagon(ctx: CanvasRenderingContext2D, x: number, y: number, isSelected: boolean, args: any = null, colorFill: any) {

    let smallradius = (this.smallButtonScale * (this.radius / 3));

    ctx.beginPath();
    ctx.moveTo(x + smallradius * Math.cos(0), y + smallradius * Math.sin(0));

    //Draw hexagon sides
    for (let side = 0; side < 7; side++) {
      ctx.lineTo(x + smallradius * Math.cos(side * 2 * Math.PI / 6), y + smallradius * Math.sin(side * 2 * Math.PI / 6));
    }

    //pick fill type
    /*if (isSelected) {
      ctx.fillStyle = "#ff0000";
      ctx.fill();
    }

    if (args.type === ButtonTypes.ONE_TO_FIVE_CHILD) {
      if (args.thisCell <= args.parent.value) {
        ctx.fillStyle = "#0000ff";
        ctx.fill();
      } else {
        ctx.fillStyle = "#00ff00";
        ctx.fill();
      }
    }

    if (args.type === ButtonTypes.CELL_COLOR || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE) {
      //this.log("this is a color type");
      //console.dir(args);
      ctx.fillStyle = args.color;
      ctx.fill();
    }

    //selected clarity cell
    if (args.selected && (args.type === ButtonTypes.CELL_CLARITY_IMAGE || args.type === ButtonTypes.CELL_CLARITY_NO_IMAGE)) {
      ctx.fillStyle = "#ffffff";
      ctx.fill();
    }*/

    ctx.fillStyle = colorFill;
    ctx.fill();

    /*
    //selected color cell => show bee icon
    if (args.selected && args.type === ButtonTypes.COLOR_CHILD) {
      ctx.fillStyle = "#0000ff"; //"#ffdd58";
      ctx.fill();
    }*/

    ctx.strokeStyle = "#ffcc00";
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  //TODO cache
  //draw the image(s) and label(s)
  private DrawImage(ctx: CanvasRenderingContext2D, x: number, y: number, isSelected: boolean, b: any, radius: number) {
    (function (_ctx, _x, _y, _b, _radius) {

      let im = new Image();
      im.src = _b.svgPath; //"assets/svg/apple.png"; //"http://www.html5canvastutorials.com/demos/assets/darth-vader.jpg";
      im.onload = function () {
        /*let sizeModifier = .75;
        let imSize = _radius * 2;
        _ctx.drawImage(im, _x - (_radius * sizeModifier), _y - (_radius * sizeModifier), imSize * sizeModifier, imSize * sizeModifier);*/
        let sizeModifier = _b.label ? .5 : .75;
        let imSize = _radius * 2;
        //let sizeModifier = _b.label?1:1.5;
        //let posModifier = b.label? .55  :  .75;
        let posModifier = b.label ? 1.5 : 1;
        _ctx.drawImage(im, _x - (_radius * sizeModifier), _y - ((_radius * sizeModifier) * posModifier), imSize * sizeModifier, imSize * sizeModifier);
        //_ctx.drawImage(im, _x - (this.size * posModifier), _y - (this.size * .75), this.size * sizeModifier, this.size * sizeModifier);

        if (b.label) {
          ctx.textAlign = "center";
          ctx.fillStyle = "#000000";
          this.DrawString(this._CONTEXT, b.label, _x, _y + imSize / 4.4, "#000000", null, null, 10)
        }
      }.bind(this);
    }.bind(this))(ctx, x, y, b, radius);

  }

  //draw a string at a specific position, with a specific color, rotation, font (size)
  private DrawString(ctx, text, posX, posY, textColor, rotation, font, fontSize) {

    let lines = text.split("\n");
    if (!rotation) rotation = 0;
    if (!font) font = "'serif'";
    if (!fontSize) fontSize = 16;
    //fontSize = 16;
    if (!textColor) textColor = '#000000';

    ctx.save();

    ctx.font = fontSize + "px " + font;

    ctx.fillStyle = textColor;

    ctx.translate(posX, posY);

    ctx.rotate(rotation * Math.PI / 180);

    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i], 0, i * fontSize);
    }
    ctx.restore();

  }

  private log(s: string): void {
    console.log("[beer-iba] " + s);
  }
}
